import { render, staticRenderFns } from "./cardProductCollections.vue?vue&type=template&id=6504f73e&"
import script from "./cardProductCollections.vue?vue&type=script&lang=js&"
export * from "./cardProductCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports